const save = (key, data) => {
  const savedData = localStorage.getItem('vacantest');
  const updatedData = { ...JSON.parse(savedData), [key]: data };
  localStorage.setItem('vacantest', JSON.stringify(updatedData));
};

const check = (card) => {
  const savedData = JSON.parse(localStorage.getItem('vacantest'));

  if (savedData) return Object.keys(savedData).includes(card.toString());

  return false;
};

const get = (card) => {
  if (check(card)) return JSON.parse(localStorage.getItem('vacantest'))[card];

  return false;
};

const remove = (card) => {
  if (check(card)) {
    const vacantest = JSON.parse(localStorage.getItem('vacantest'));
    const updatedVacantest = { ...vacantest };

    delete updatedVacantest[card];

    localStorage.setItem('vacantest', JSON.stringify(updatedVacantest));
  }
};

const clear = () => localStorage.removeItem('vacantest');

const localStorageVacantest = {
  save,
  check,
  get,
  remove,
  clear,
};

export default localStorageVacantest;
